module.exports = __webpack_public_path__ + "static/northstar-6fcd55da8077d6f3a8293280f81b033f.jpg";